export default __webpack_public_path__ + "static/media/3d-logo.86757b63.svg";